import React from "react";
import classNames from "classnames";
import { Link as InertiaLink } from "@inertiajs/react";
import type { ComponentType } from "react";
import type { IconProps } from "@sprout/icons/base.tsx";

type Icon = ComponentType<IconProps>;

type SharedProps = {
  icon: Icon;
  size?: "sm" | "md";
};

interface IconButtonProps extends SharedProps {
  label: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
}

export const IconButton = ({
  icon: IconComponent,
  onClick,
  size = "sm",
  label,
  disabled,
  ...dataProps
}: IconButtonProps) => {
  const className = classNames({
    "icon-button": true,
    [`icon-button--${size}`]: true,
    [`icon-button--disabled`]: disabled,
  });

  return (
    <button
      {...dataProps}
      type="button"
      className={className}
      aria-label={label}
      onClick={onClick}
      disabled={disabled}
    >
      <IconComponent size={size} />
    </button>
  );
};

interface IconButtonLinkProps extends SharedProps {
  href: string;
  external?: boolean;
}

export const IconButtonLink = ({
  href,
  icon: IconComponent,
  size,
  external = false,
  ...dataProps
}: IconButtonLinkProps) => {
  const className = classNames({
    "icon-button": true,
    [`icon-button--${size}`]: true,
  });

  const Link = external ? "a" : InertiaLink;
  const target = external ? "_blank" : undefined;
  const rel = external ? "noopener noreferrer" : undefined;

  return (
    <Link {...dataProps} className={className} href={href} target={target} rel={rel}>
      <IconComponent size={size} />
    </Link>
  );
};
